import React, { useEffect } from 'react';
import { Sun, Moon, Menu } from 'lucide-react';
import AnimatedCounter from './AnimatedCounter';

const Header = ({ isDarkMode, onThemeToggle , totalCount,setIsMenuOpen,isMenuOpen }) => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes gradient-shift {
        0% {
          background-position: 0% 50%;
          transform: rotate(0deg);
        }
        50% {
          background-position: 100% 50%;
          transform: rotate(1deg);
        }
        100% {
          background-position: 0% 50%;
          transform: rotate(0deg);
        }
      }

      @keyframes dots-shift {
        0% {
          transform: translateX(0) translateY(0);
          opacity: 0.2;
        }
        25% {
          transform: translateX(10px) translateY(-10px);
          opacity: 0.3;
        }
        50% {
          transform: translateX(20px) translateY(0px);
          opacity: 0.2;
        }
        75% {
          transform: translateX(10px) translateY(10px);
          opacity: 0.3;
        }
        100% {
          transform: translateX(0) translateY(0);
          opacity: 0.2;
        }
      }

      @keyframes dots-pulse {
        0%, 100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.5);
        }
      }

      .animated-gradient {
        background-size: 300% 300% !important;
        animation: gradient-shift 15s ease infinite;
      }

      .animated-dots {
        animation: dots-shift 20s ease infinite;
      }

      .dots-pattern::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: radial-gradient(circle at center, currentColor 1px, transparent 1px);
        background-size: 16px 16px;
        animation: dots-pulse 10s ease infinite;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="relative overflow-hidden sticky top-0 z-50">
      {!isMenuOpen && 
        <Menu className="block lg:hidden relative overflow-hidden sticky top-0 z-50 text-white text-2xl ml-2 mt-2" onClick={()=>setIsMenuOpen(true)}/>}
      {/* Animated background layers */}
      <div className="absolute inset-0">
        {/* Primary gradient layer */}
        <div className={`
          absolute inset-0 animated-gradient
          ${isDarkMode 
            ? 'bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800' 
            : 'bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500'
          }
        `} />

        {/* Secondary gradient layer */}
        <div className={`
          absolute inset-0 opacity-30 animated-gradient
          ${isDarkMode 
            ? 'bg-gradient-to-tr from-gray-900 via-gray-800 to-gray-900' 
            : 'bg-gradient-to-tr from-blue-500 via-purple-600 to-pink-600'
          }
        `} style={{ animationDelay: '-5s' }} />

        {/* Moving dots pattern - Layer 1 */}
        <div className={`
          absolute inset-0 animated-dots dots-pattern
          ${isDarkMode ? 'text-gray-600' : 'text-white'}
        `} style={{ opacity: 0.2 }} />

        {/* Moving dots pattern - Layer 2 */}
        <div className={`
          absolute inset-0 animated-dots dots-pattern
          ${isDarkMode ? 'text-gray-500' : 'text-white'}
        `} style={{ 
          opacity: 0.1, 
          animationDelay: '-7s',
          transform: 'rotate(45deg)'
        }} />
      </div>

      {/* Content */}
      <div className="relative">
        <div className="container mx-auto px-6 py-12">
      
          <div className="flex flex-col md:flex-row justify-between items-center">
          <AnimatedCounter isDarkMode={isDarkMode} totalCount={totalCount}/>
            <div>
              <h1 className="text-4xl font-bold text-white mb-2">
                CSS Loader Collection
              </h1>
             
              <div className="h-1 w-20 rounded bg-white/30 transition-all duration-300 group-hover:w-full" />
            
            </div>
            

            {/* Theme toggle button with enhanced glass effect */}
            <button
              onClick={onThemeToggle}
              className={`
                p-3 rounded-full
                backdrop-blur-md
                transition-all duration-300 transform
                ${isDarkMode 
                  ? 'bg-gray-700/30 hover:bg-gray-600/30' 
                  : 'bg-white/20 hover:bg-white/30'
                }
                shadow-lg hover:shadow-xl
                hover:scale-110
                group
              `}
              title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
            >
              <div className="transform transition-transform group-hover:rotate-12">
                {isDarkMode ? (
                  <Sun size={24} className="text-white" />
                ) : (
                  <Moon size={24} className="text-white" />
                )}
              </div>
            </button>
          </div>
        </div>

        {/* Original wave shape */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg
            className="w-full h-8 fill-current"
            preserveAspectRatio="none"
            viewBox="0 0 1440 48"
            style={{ 
              fill: isDarkMode ? '#1f2937' : '#f9fafb',
              filter: 'drop-shadow(0 -1px 1px rgba(0,0,0,0.05))'
            }}
          >
            <path d="M0 48h1440V0c-624 43.044-816 43.044-1440 0v48z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Header;